import {
  IPRangeListTargetingModel,
  IPRangeListTargetingItemModel,
  GetIPRangeListTargetingListForm,
} from '@/models/IPRangeListTargeting'
const assignModel = data => {
  return data.map(o => new IPRangeListTargetingModel(o))
}
const assignItemModel = data => {
  return data.map(o => new IPRangeListTargetingItemModel(o))
}
const actions = {
  async GET_LISTS_FOR_OEM({ commit }, { pageNo, pageSize, ownerProfileId }) {
    const params = new GetIPRangeListTargetingListForm({
      pageNo,
      pageSize,
      ownerProfileId,
    })
    let listData = await IPRangeListTargetingModel.findByOwnerProfileId(params)
    const { items } = listData
    const modeledItems = assignModel(items)
    commit('SET_LISTS', modeledItems)
  },

  async GET_LISTS_FOR_ADVERTISER(
    { commit },
    { pageNo, pageSize, advertiserId },
  ) {
    const params = new GetIPRangeListTargetingListForm({
      pageNo,
      pageSize,
    })
    let listData = await IPRangeListTargetingModel.findByAdvertiserId(
      params,
      advertiserId,
    )
    const { items } = listData
    const modeledItems = assignModel(items)
    commit('SET_LISTS', modeledItems)
  },

  async GET_ITEMS({ commit }, { ipRangeListId, pageNo, pageSize }) {
    // 201907 一旦実装しない扱いの機能、作ってしまったので置いておく
    //  async GET_LIST({ commit }, { pageNo, pageSize, ownerProfileId }) {
    /*
      API待ち
    const listData = await IPRangeListTargetingApi.fetchIPRangeListTargetingList(
      new GetIPRangeListTargetingListForm({ pageNo, pageSize, ownerProfileId }),
    )
    const { items } = listData
    const modeledItems = assignModel(items)
    */
    const params = { pageNo, pageSize }
    console.log(params)
    console.log(ipRangeListId)
    /*
    API待ち
    const listData = await IPRangeListTargetingApi.fetchIPRangeListTargeting(params, ipRangeListId),
    )
    const { items } = listData
    const modeledItems = assignModel(items)
    */
    const modeledItems = assignItemModel([
      {
        from: '123.123.123.123',
        to: '129.999.999.999',
      },
      {
        from: '223.123.123.123',
        to: '223.999.999.234',
      },
    ])
    console.log(modeledItems)
    commit('SET_ITEMS', modeledItems)
  },
}

export default actions
